module.exports = __webpack_public_path__ + "img/04.f8de88a4.png";